import styled, { css } from 'styled-components'
import { shimmerAnim } from '../../../utils'

type StyledProps = {
  $loading?: boolean
  $show?: boolean
}

const StyledLessonSidebar = styled.div<StyledProps>`
  user-select: none;
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.color.gray[100]};
  flex-shrink: 0;
  z-index: ${({ theme }) => theme.elevation.override};
  box-shadow: -2px 0 10px rgb(0, 0, 0, 0.05), -10px 0 20px rgb(0, 0, 0, 0.05);
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);

  .header {
    padding: 14px;
    background-color: ${({ theme }) => theme.color.background};
    border-bottom: 1px solid ${({ theme }) => theme.color.gray[300]};

    .header-group {
      display: flex;
      justify-content: space-between;

      .course-details {
        span {
          display: -webkit-box;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-align: left;
          -webkit-box-orient: vertical;
        }

        .course-title {
          font-weight: 600;
          font-size: 15px;
          color: ${({ theme }) => theme.color.gray[800]};
        }

        .course-progress {
          font-size: 13px;
          font-weight: 500;
          margin-top: 6px;
          color: ${({ theme }) => theme.color.gray[500]};
        }
      }
    }

    .expand-btn {
      flex-shrink: 0;
      margin-left: 14px;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: ${({ theme }) => theme.color.gray[200]}c4;
      color: ${({ theme }) => theme.color.gray[600]};

      svg {
        height: 24px;
      }
    }

    .progress {
      height: 6px;
      border-radius: 50rem;
      margin-top: 14px;
      overflow: hidden;
      background-color: ${({ theme }) => theme.color.green[700]}40;

      .progress-value {
        height: 100%;
        transition: 0.2s;
        border-radius: 50rem;
        background-color: ${({ theme }) => theme.color.green[700]};
      }
    }
  }

  .module-list {
    overflow-y: auto;
  }

  ${({ $loading }) =>
    $loading &&
    css`
      .header {
        .header-group {
          .course-details {
            .course-title {
              height: 18px;
              max-width: 100%;
              width: 160px;
              border-radius: 6px;
              animation: ${shimmerAnim} 1.4s ease-in-out infinite;
            }

            .course-progress {
              height: 15.5px;
              width: 88px;
              border-radius: 6px;
              animation: ${shimmerAnim} 1.4s ease-in-out infinite;
            }
          }
        }

        .progress {
          animation: ${shimmerAnim} 1.4s ease-in-out infinite;
        }
      }
    `}

  @media (min-width: ${({ theme }) => theme.breakpoint.s}px) {
    width: 340px;
    position: sticky;
    top: 70px;
    bottom: unset;
    height: calc(100dvh - 70px);
    z-index: ${({ theme }) => theme.elevation.sticky};
  }
`

export default StyledLessonSidebar
